import React from "react";

// Components
import { faEllipsis, faEnvelope, faMoneyCheckDollar, faPaintBrush, faText } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IonLabel, IonSegment, IonSegmentButton } from "@ionic/react";
import { useTranslation } from "react-i18next";

// Types
import { CurrentSegmentState } from "../../../pages/Admin/Settings/SettingsTypes";

export default function SettingsSegment({ currentSegment, updateSegment }: { currentSegment: CurrentSegmentState; updateSegment: (event: CustomEvent) => void }) {
  const { t } = useTranslation();

  return (
    <IonSegment value={currentSegment} scrollable={true} onIonChange={updateSegment} swipeGesture={true} className={"ion-margin-top"}>
      <IonSegmentButton value="brand">
        <FontAwesomeIcon icon={faPaintBrush} />
        <IonLabel>{t("brand")}</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="sponsors">
        <FontAwesomeIcon icon={faMoneyCheckDollar} />
        <IonLabel>{t("sponsors")}</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="global-wording">
        <FontAwesomeIcon icon={faText} />
        <IonLabel>{t("globalWording")}</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="emails">
        <FontAwesomeIcon icon={faEnvelope} />
        <IonLabel>{t("emails")}</IonLabel>
      </IonSegmentButton>
      <IonSegmentButton value="miscellaneous">
        <FontAwesomeIcon icon={faEllipsis} />
        <IonLabel>{t("miscellaneous")}</IonLabel>
      </IonSegmentButton>
    </IonSegment>
  );
}
